<template>
  <div>
    <div v-if="loading" class="loader">
      <bb-spinner/>
    </div>
    <credit-card-limits-modal
      v-else-if="visible"
      :card="card"
      :card-id="Number(cardId)"
      :contract-id="Number(contractId)"
      :visible="visible"
      is-mobile-app
      :limits="limitsConfiguration"
      @onModalClosed="onModalClosed"
    />
    <credit-card-action-done v-else />
  </div>
</template>

<script>
import api from '@loan/api'
import CreditCardActionDone from '@credit-card/views/mobile-standalone/CreditCardActionDone.vue'
import CreditCardLimitsModal from '@credit-card/components/modals/CreditCardLimitsModal.vue'
import { mapActions } from 'pinia'
import { useLoanStore } from '@loan/store/loanStore'

export default {
  name: 'credit-card-limits-page',
  components: { CreditCardLimitsModal, CreditCardActionDone },
  props: {
    cardId: {
      type: String,
      required: true
    },
    contractId: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      card: null,
      visible: false,
      loading: false,
      limitsConfiguration: null
    }
  },
  async created () {
    try {
      this.loading = true
      const [card, limitsConfiguration] = await Promise.all([
        api.getCreditCardByCardId(this.cardId),
        api.getCreditCardLimitsConfiguration(this.cardId),
        this.contractId ? null : this.getContract()
      ])
      this.limitsConfiguration = limitsConfiguration
      this.card = card
      this.visible = true
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions(useLoanStore, ['getContract']),
    onModalClosed () {
      this.visible = false
    }
  }
}
</script>
